module.exports = __webpack_public_path__ + "media/images/flags/64/Albania-97cfddfc61edaf7a2a441baecd1a5971.png";